define(function (require, exports, module) {
    'use strict';

    var UploadFail = require('./UploadFail');

    /**
     * @constructor
     * @extends {UploadFail}
     * @param {Error} stack
     * @param {string} source
     */
    function UserNoAuthFail(stack, source) {
        UploadFail.apply(this, arguments);
    }

    UserNoAuthFail.prototype = Object.assign(Object.create(UploadFail.prototype), {
        constructor: UserNoAuthFail,
        className: 'UserNoAuthFail',
        radarName: 'fail_{SOURCE}_user-no-auth',
        message: 'Вы не авторизованы.',
    });

    module.exports = UserNoAuthFail;
});
